import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { deleteAccountingDocument, getPaymentRequest, uploadAccountingDocument } from "redux/erp/paymentRequestSlice";
import AttachmentsPanel from "../common/AttachmentsPanel";

/**
 * Files Accounting adds while completing the request (kind = accounting) — on the
 * Request information tab, next to what the requestor attached. They stay in the
 * Portal: the ERP API has nowhere to receive files.
 */
const AccountingAttachments = ({ paymentRequest: pr, editable }) => {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const docs = (pr.documents || []).filter((d) => d.kind === "accounting");

  const upload = async (files) => {
    const fd = new FormData();
    files.forEach((f) => fd.append("documents[]", f));
    setUploading(true);
    try {
      const res = await dispatch(uploadAccountingDocument({ id: pr.id, formData: fd })).unwrap();
      toast.success(res?.message || "Uploaded.");
      dispatch(getPaymentRequest(pr.id));
    } catch {
      /* toasted by the slice */
    } finally {
      setUploading(false);
    }
  };

  const remove = async (_idx, doc) => {
    try {
      await dispatch(deleteAccountingDocument({ id: pr.id, documentId: doc.id })).unwrap();
      dispatch(getPaymentRequest(pr.id));
    } catch {
      /* toasted by the slice */
    }
  };

  if (!editable && docs.length === 0) return null;

  return (
    <section aria-label="Accounting attachments"
      className="tw-bg-geist-bg tw-rounded-geist-md tw-border tw-border-solid tw-border-geist-border tw-shadow-geist-card tw-p-5">
      <AttachmentsPanel attachments={docs} readOnly={!editable} uploading={uploading} onUpload={upload} onRemove={remove} />
    </section>
  );
};

AccountingAttachments.propTypes = {
  paymentRequest: PropTypes.object.isRequired,
  // The accounting desk may add / remove files; others only see them.
  editable: PropTypes.bool,
};

export default AccountingAttachments;
